<template>
  <div class="home2">
    <div class="bg1" id="banner" @click="bannerClick">
      <div class="form">
        <ul class="clearfix" id="scroll">
          <li class="fl active">
            <a href="javascript:;" class="colors">轰轰龙</a>
          </li>
          <li class="fl">
            <a href="javascript:;">嗨，顾得白</a>
          </li>
          <li class="fl">
            <a href="javascript:;">托雷的玩具城</a>
          </li>
          <li class="fl">
            <a href="javascript:;">翻开这一页</a>
          </li>
          <li class="fl">
            <a href="javascript:;">熊猫博士</a>
          </li>
        </ul>
      </div>
    </div>
    <img-show listTitle="动画片排行榜" dataKey="ranking"></img-show>
    <img-show listTitle="最新上映" dataKey="latest"></img-show>
    <img-show listTitle="热播动画" dataKey="hot"></img-show>
    <img-show listTitle="国产原创" dataKey="original"></img-show>

    <!-- <puzzle-video listTitle="动画视频" dataKey="videoType"></puzzle-video> -->

    <!-- <puzzle-video listTitle="益智动画" dataKey="puzzle"></puzzle-video> -->
    <!-- <puzzle-video listTitle="爱国科普" dataKey="patriotic"></puzzle-video>
    <puzzle-video listTitle="科学启蒙" dataKey="science"></puzzle-video>
    <puzzle-video listTitle="小猴启蒙" dataKey="monkey"></puzzle-video>
    <puzzle-video listTitle="生活中的科学" dataKey="life"></puzzle-video> -->
    <!-- <index-video></index-video> -->
  </div>
</template>

<script>
import $ from "jquery";
// import indexVideo from "./index.vue";
// import puzzleVideo from "./Detail/Puzzle.vue";
import imgShow from "./Detail/imgShow.vue";

export default {
  components: {
    // indexVideo,
    // puzzleVideo,
    imgShow,
  },
  data() {
    return {};
  },
  mounted() {
    window.scrollTo(0, 0);
    //
    var aDiv = $("#banner");
    var oUl = $("#scroll");
    var aLi = oUl.children();
    var n = 0;
    var oA = aLi.children();

    aLi.mouseenter(function () {
      n = $(this).index();
      aLi.removeClass("active");
      oA.removeClass("colors");
      aLi.eq($(this).index()).addClass("active");

      changeBg();

      oA.eq($(this).index()).addClass("colors");
    });

    var timer = setInterval(tick, 3000);
    aLi.mouseenter(function () {
      clearInterval(timer);
    });
    aLi.mouseleave(function () {
      timer = setInterval(tick, 3000);
    });

    function tick() {
      n++;
      if (n == aLi.length) {
        n = 0;
      }
      oA.removeClass("colors");
      oA.eq(n).addClass("colors");
      aLi.eq(n).addClass("active").siblings().removeClass("active");

      changeBg();
    }

    function changeBg() {
      aDiv.removeClass();
      aDiv.addClass(`bg1 bg${n + 1}`);
      // if(n + 1 === 2){
      //   aDiv.removeClass('bg3')
      //   aDiv.addClass('bg2')
      // } else if(n + 1 === 3){
      //   aDiv.removeClass('bg2')
      //   aDiv.addClass('bg3')
      // } else {
      //   aDiv.removeClass('bg2')
      //   aDiv.removeClass('bg3')
      // }
    }
  },
  methods: {
    bannerClick() {
      var aDiv = $("#banner");
      var className = aDiv.attr("class");
      var num = className.substr(className.length - 1);
      if (num === "1") {
        this.$router.push(`/commonDetail?id=car`);
      } else if (num === "2") {
        this.$router.push(`/commonDetail?id=precious`);
      } else if (num === "3") {
        this.$router.push(`/commonDetail?id=toy2`);
      } else if (num === "4") {
        this.$router.push(`/commonDetail?id=Onepage02`);
      } else if (num === "5") {
        this.$router.push(`/detail${num}`);
      }
    },
  },
};
</script>

<style scoped>
.home2 {
  width: 100%;
  margin-top: 60px;
  position: relative;
}
.bg1 {
  /* background: url(../assets/header/tuotuo1.png) repeat-x center top #010101; */
  background: url(../assets/ca/1.jpg) repeat center center #010101;
  /* height: 516px; */
  height: 520px;
  min-width: 980px;
  transition: 1s all ease;
  cursor: pointer;
}
.bg2 {
  /* background: url(../assets/header/tuotuo1.png) repeat-x center top #010101; */
  background: url(../assets/ca/2.jpg) repeat center center #010101;
}
.bg3 {
  /* background: url(../assets/header/tuotuo1.png) repeat-x center top #010101; */
  background: url(../assets/ca/3.jpg) repeat center center #010101;
}
.bg4 {
  /* background: url(../assets/header/tuotuo1.png) repeat-x center top #010101; */
  background: url(../assets/ca/4.jpg) repeat center center #010101;
}
.bg5 {
  /* background: url(../assets/header/tuotuo1.png) repeat-x center top #010101; */
  background: url(../assets/ca/5.jpg) repeat center center #010101;
}
.form .colors {
  color: #fff;
}
.form {
  /* background: url(../assets/header/bg.png) no-repeat; */
  position: absolute;
  top: 100px;
  right: 100px;
  width: 300px;
}
.form ul {
  position: absolute;
  left: 17px;
  top: 17px;
}
.form ul li {
  width: 280px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 28px;
  margin-bottom: 10px;
}
.form ul li a {
  color: #ccc;
  display: block;
}
.form .active {
  background: #688a00;
}
.clearfix:after {
  display: block;
  content: "";
  clear: both;
}
.clearfix {
  zoom: 1;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
img,
input,
select {
  vertical-align: top;
}
img {
  display: block;
  border: none;
}
li {
  list-style: none;
}
a {
  text-decoration: none;
  color: #000;
}
</style>
